import React from 'react';
import { ETestIds } from '../../constants/testIds';
import { useIsDesktop } from '../../hooks/common';
import { ERuntimeSettings } from '../../types/runtimeSettings';
import { useApplicationContext } from '../../utils/applicationContext';
import { CalculatorMicrofrontend } from '../microfrontends/CalculatorMicrofrontend';
import { ScrollToOffersButton } from '../stickyButtons/ScrollToOffersButton';
import { useCalculatorHandlers } from './hooks';

export interface IControlsContainerProps {
  offersCount: number | null;
  offersIsFetching: boolean;
}

export const ControlsContainer: React.FC<IControlsContainerProps> = ({ offersCount, offersIsFetching }) => {
  const isDesktop = useIsDesktop();
  const { config } = useApplicationContext();
  const mortgageLandingRedesignEnabled = config.get<boolean>(ERuntimeSettings.mortgageLandingRedesign);
  const { onCatchErrorCalculator, onSubmitCalculator, onSendAnalyticsCalculatorEvent } = useCalculatorHandlers();
  const showScrollToOffersButton = !isDesktop && !mortgageLandingRedesignEnabled;

  return (
    <div data-testid={ETestIds.ControlsContainer}>
      <CalculatorMicrofrontend
        onSubmitCalculatorEvent={onSubmitCalculator}
        onCatchErrorCalculatorEvent={onCatchErrorCalculator}
        onSendAnalyticsCalculatorEvent={onSendAnalyticsCalculatorEvent}
      />
      {showScrollToOffersButton ? (
        <ScrollToOffersButton offersCount={offersCount} isLoading={offersIsFetching} />
      ) : null}
    </div>
  );
};
